import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, X } from 'lucide-react';
import type { HelpContent } from '../helpContent';

export default function HelpButton({ content }: { content: HelpContent }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title={t('help.buttonTitle')}
        className="inline-flex items-center justify-center w-7 h-7 rounded-full text-slate-400 hover:text-brand-600 hover:bg-brand-50 transition-colors"
      >
        <HelpCircle size={18} />
      </button>

      {open && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className={`bg-surface rounded-xl shadow-xl w-full ${
              content.sections?.length ? 'max-w-2xl max-h-[85vh] flex flex-col' : 'max-w-md'
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-6 py-5 border-b border-slate-200 flex items-start justify-between gap-4">
              <div>
                <h2 className="text-base font-semibold text-slate-900">{content.title}</h2>
                <p className="text-sm text-slate-500 mt-1">{content.intro}</p>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="text-slate-400 hover:text-slate-600 shrink-0"
              >
                <X size={18} />
              </button>
            </div>
            <div className="px-6 py-5 space-y-5 overflow-y-auto">
              {content.points.length > 0 && (
                <ul className="space-y-3">
                  {content.points.map((point, i) => (
                    <li key={i} className="flex gap-2.5 text-sm text-slate-600">
                      <span className="text-brand-500 shrink-0">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              )}

              {content.sections?.map((abschnitt) => (
                <section key={abschnitt.titel}>
                  <h3 className="text-sm font-semibold text-slate-800 mb-2">{abschnitt.titel}</h3>
                  <ul className="space-y-2">
                    {abschnitt.punkte.map((punkt, i) => (
                      <li key={i} className="flex gap-2.5 text-sm text-slate-600">
                        <span className="text-brand-500 shrink-0">•</span>
                        <span>{punkt}</span>
                      </li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
            <div className="px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 text-sm bg-brand-600 hover:bg-brand-700 text-white rounded-lg"
              >
                Verstanden
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
